<template>
  <b-nav-item-dropdown
    ref="dropdown"
    right
    toggle-class="d-flex align-items-center dropdown-user-link"
    class="dropdown-user"
  >
    <template #button-content>
      <div class="d-sm-flex d-none user-nav">
        <p class="user-name font-weight-bolder mb-0">
          {{ user.name }}
        </p>
      </div>
      <b-avatar
        size="40"
        variant="light-primary"
        :src="user.avatar"
        class="badge-minimal"
      />
    </template>
    <b-dropdown-item
      v-if="isSuperAdmin"
      link-class="d-flex align-items-center"
      @click="toggleSuperAdminView"
    >
      <feather-icon
        size="16"
        icon="AirplayIcon"
        class="mr-50"
      />
      <span>{{ onSuperAdminRoutes ? $t('menu.normal-user') : $t('menu.management') }}</span>
    </b-dropdown-item>
    <b-dropdown-text link-class="d-flex align-items-center">
      <dark-toggler />
    </b-dropdown-text>

    <b-dropdown-item
      v-if="androidAppUrl"
      link-class="d-flex align-items-center"
      :href="androidAppUrl"
      target="_blank"
      rel="noopener noreferrer"
    >
      <feather-icon
        size="16"
        icon="DownloadIcon"
        class="mr-50"
      />
      <span>{{ $t('menu.download_android_app') || 'Download Android App' }}</span>
    </b-dropdown-item>

    <b-dropdown-item
      link-class="d-flex align-items-center text-primary"
      @click="logout"
    >
      <feather-icon
        size="16"
        icon="LogOutIcon"
        class="mr-50"
      />
      <span>{{ $t('auth.logout') }}</span>
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
import {
  BAvatar, BDropdownItem, BNavItemDropdown, BDropdownText, VBToggle, VBModal,
} from 'bootstrap-vue'
import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'ProfileActionsDropdown',
  components: {
    DarkToggler,
    BNavItemDropdown,
    BDropdownItem,
    BDropdownText,
    BAvatar,
  },
  directives: {
    'b-toggle': VBToggle,
    'b-modal': VBModal,
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      isSuperAdmin: 'auth/isAdmin',
      onSuperAdminRoutes: 'navigation/isAdminRoute',
      androidAppUrl: 'auth/androidAppUrl',
    }),
  },
  methods: {
    logout() {
      this.$store.dispatch('auth/LOGOUT')
      window.location.replace(this.$router.resolve({ name: 'login' }).href)
    },
    toggleSuperAdminView() {
      if (this.onSuperAdminRoutes) {
        this.$router.push({ name: 'owner:home' }).catch(() => { })
      } else {
        this.$router.push({ name: 'admin:home' })
      }
    },
  },
}
</script>
<style lang="scss">
.dropdown-user .dropdown-menu{
  width: 13rem !important;
}
</style>
